import Typography from '@ui/Typography';
import React, { useEffect, useState } from 'react';
import NonProfitOnBoardFormFinalStep from './NonProfitOnBoardFormFinalStep';
import NonProfitOnBoardFormLocationStep from './NonProfitOnBoardFormLocationStep';
import NonProfitOnBoardFormProfileStep from './NonProfitOnBoardFormProfileStep';
import { MULTIPART_FORM_DATA_HEADER, requestPost } from '@utils/httpService';
import NonProfitOnBoardFormCredentialStep from './NonProfitOnBoardFormCredentialStep';
import NonProfitOnBoardFormAboutStep from './NonProfitOnBoardFormAboutStep';

function NonProfitOnBoardForm(props) {
  const { nonProfitId, onSubmit, setDialogStep } = props;
  const [step, setStep] = useState('credential');
  const [formData, setFormData] = useState({});

  const handleFormSubmit = (data) => {
    switch (step) {
      case 'credential':
        setFormData({
          ...formData,
          ...data,
        });
        setStep('profile');
        break;
      case 'profile':
        setFormData({
          ...formData,
          ...data,
        });

        setStep('location');
        break;
      case 'location':
        setFormData({
          ...formData,
          ...data,
        });
        setStep('about');
        break;
      case 'about':
        setFormData({
          ...formData,
          ...data,
        });
        setStep('final');
        setDialogStep('final');
        break;
      case 'final':
        const payload = {
          ...formData,
          ...data,
        };
        setDialogStep('');
        setFormData(payload);
        onSubmit(payload);
      default:
        break;
    }
  };

  const handleBack = () => {
    switch (step) {
      case 'profile':
        setDialogStep('credential');
        setStep('credential');
        break;
      case 'location':
        setDialogStep('profile');
        setStep('profile');
        break;
      case 'about':
        setDialogStep('location');
        setStep('location');
        break;
      case 'final':
        setDialogStep('about');
        setStep('about');
        break;
    }
  };

  if (step === 'credential') {
    return (
      <NonProfitOnBoardFormCredentialStep
        onSubmit={handleFormSubmit}
        formData={formData}
      />
    );
  }

  if (step === 'profile') {
    return (
      <NonProfitOnBoardFormProfileStep
        onSubmit={handleFormSubmit}
        onBack={handleBack}
        formData={formData}
      />
    );
  }
  if (step === 'location') {
    return (
      <NonProfitOnBoardFormLocationStep
        onSubmit={handleFormSubmit}
        onBack={handleBack}
        formData={formData}
      />
    );
  }
  if (step === 'about') {
    return (
      <NonProfitOnBoardFormAboutStep
        onSubmit={handleFormSubmit}
        onBack={handleBack}
        formData={formData}
      />
    );
  }
  if (step === 'final') {
    return (
      <NonProfitOnBoardFormFinalStep
        onSubmit={handleFormSubmit}
        onBack={handleBack}
      />
    );
  }
  return null;
}

export default NonProfitOnBoardForm;
